import AgGridTooltip, {
  type CombinedTooltipProps,
} from 'components/AgGrid/Tooltip';
import { checkDeviceStatus } from 'store/utils';
import { useTranslation } from 'react-i18next';

const AssetTooltip = (props: CombinedTooltipProps) => {
  const { t } = useTranslation();
  const { data, bgColor, color } = props;
  const [isMissing, isActive, isXYFound] = checkDeviceStatus(data?.device);

  return (
    <>
      <AgGridTooltip bgColor={bgColor} color={color}>
        {isMissing ? (
          <p>{t('no_device_detected')} </p>
        ) : !isXYFound ? (
          <>
            <p>
              {t('device_orientation_must_be_specified_for_activation')}
              <br />
              {t('click_the_link_to_update')}
            </p>
          </>
        ) : !isActive ? (
          <p>{t('device_not_active')}</p>
        ) : null}
      </AgGridTooltip>
    </>
  );
};

export default AssetTooltip;
